/**
 * Main module entities for PitchForge
 * These entities are used across presentation, domain hooks, and API layers.
 */

export enum PitchSortBy {
  UPDATED_AT_DESC = "updated_at_desc",
  UPDATED_AT_ASC = "updated_at_asc",
  TITLE_ASC = "title_asc",
  TITLE_DESC = "title_desc",
}

/**
 * Represents a single pitch stored under a team.
 * - Soft delete supported via deletedAt (null = active).
 * - Body is the AI-generated/edited rich text (stored as markdown/HTML/plaintext - transport agnostic here).
 */
export interface Pitch {
  id: string;
  teamId: string;
  createdByUserId: string;

  title: string;
  body: string;

  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
}

/**
 * Payload for generating a pitch from the manual input form.
 * These inputs are sent to the LLM generation workflow server-side.
 */
export interface PitchFormDraft {
  productTitle: string;
  productDescription: string;
  targetCustomer: string | null;
  customerPainPoint: string | null;
  additionalContext: string | null;
}

/**
 * Simple toast entity used by the workspace to convey feedback.
 */
export interface ToastMessage {
  id: string;
  message: string;
  type: "success" | "error" | "info";
  createdAt: Date;
}